import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  FormlyFieldProps as CoreFormlyFieldProps,
  FieldWrapper,
  FormlyFieldConfig,
  FormlyModule,
} from '@ngx-formly/core';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';

export interface FormlyFieldProps extends CoreFormlyFieldProps {
  hideRequiredMarker?: boolean;
  hideLabel?: boolean;
  mandatory?: boolean;
  mandatoryMessage?: string;
  tooltip?: string;
  infoButton?: {
    visible: boolean;
    onClick?: () => void;
  };
}

@Component({
  selector: 'kon-form-field-wrapper',
  standalone: true,
  imports: [CommonModule, FormlyModule, TooltipModule, ButtonModule],
  template: `
    <div class="p-field flex flex-col mb-4">
      <label
        *ngIf="props.label && props.hideLabel !== true"
        [for]="id"
        class="mb-1"
      >
        {{ props.label }}
        @if(props.required && props.hideRequiredMarker !== true) {
        <span aria-hidden="true">*</span>
        } @if(props.mandatory) {
        <span [pTooltip]="props.mandatoryMessage"> &diams; </span>
        } @if(props.tooltip) {
        <span [pTooltip]="props.tooltip"> &#9432; </span>
        } @if(props.infoButton?.visible) {
        <span
          (click)="props.infoButton?.onClick && props.infoButton?.onClick()"
          class="pi pi-info-circle cursor-pointer text-sm"
        >
        </span>

        }
      </label>

      <ng-container #fieldComponent></ng-container>

      <small *ngIf="showError" class="p-error">
        <formly-validation-message
          class="ui-message-text"
          [field]="field"
        ></formly-validation-message>
      </small>

      <small *ngIf="props.description" class="p-help">
        {{ props.description }}
      </small>
    </div>
  `,

  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFormFieldWrapperComponent extends FieldWrapper<
  FormlyFieldConfig<FormlyFieldProps>
> {
  // @HostBinding('class.p-float-label') floatLabel = true;
}
